"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.isAltAvailable = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gatsbyImage = _interopRequireDefault(require("gatsby-image"));

var _core = require("@material-ui/core");

var _Hocs = require("../../Hocs");

var _useStyles2 = _interopRequireDefault(require("./useStyles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var isAltAvailable = function isAltAvailable(alt) {
  return typeof alt === 'string' && alt.length > 0;
};

exports.isAltAvailable = isAltAvailable;

var Field = function Field(_ref) {
  var lists = _ref.lists,
      fill = _ref.fill,
      spacing = _ref.spacing,
      gatsbyImageClass = _ref.gatsbyImageClass,
      rest = _objectWithoutProperties(_ref, ["lists", "fill", "spacing", "gatsbyImageClass"]);

  var _useStyles = (0, _useStyles2["default"])({
    fill: fill
  }),
      body1 = _useStyles.body1,
      card = _useStyles.card,
      cardTitle = _useStyles.cardTitle,
      li = _useStyles.li,
      noCta = _useStyles.noCta,
      subtitle = _useStyles.subtitle,
      ul = _useStyles.ul,
      gatsbyImage = _useStyles.gatsbyImage;

  return /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    container: true,
    spacing: spacing,
    component: "ul",
    className: ul
  }, lists.map(function (img, i) {
    var getCardProps = function getCardProps() {
      return img.onClick ? {
        role: 'link',
        className: card,
        tabIndex: 0
      } : {
        className: [card, noCta].join(' ')
      };
    };

    return /*#__PURE__*/_react["default"].createElement(_core.Grid, _extends({
      item: true,
      className: li,
      component: "li",
      key: i
    }, rest), /*#__PURE__*/_react["default"].createElement(_core.Card, _extends({
      onClick: img.onClick,
      onKeyPress: img.onClick
    }, getCardProps()), /*#__PURE__*/_react["default"].createElement("div", {
      "aria-hidden": !isAltAvailable(img.alt)
    }, /*#__PURE__*/_react["default"].createElement(_gatsbyImage["default"], {
      fluid: img.fluid,
      imgStyle: {
        objectFit: 'cover'
      },
      className: gatsbyImageClass || gatsbyImage,
      alt: img.alt || ''
    })), /*#__PURE__*/_react["default"].createElement(_core.CardContent, null, img.subtitle ? /*#__PURE__*/_react["default"].createElement("span", {
      className: subtitle
    }, img.subtitle) : null, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
      variant: "h3",
      className: cardTitle
    }, img.title), /*#__PURE__*/_react["default"].createElement(_core.Typography, {
      variant: "body1",
      className: body1
    }, img.description))));
  }));
};

Field.propTypes = {
  lists: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    title: _propTypes["default"].string,
    description: _propTypes["default"].string,
    src: _propTypes["default"].string,
    onClick: _propTypes["default"].func
  })).isRequired,
  fill: _propTypes["default"].bool,
  lg: _propTypes["default"].number,
  xs: _propTypes["default"].number,
  sm: _propTypes["default"].number,
  md: _propTypes["default"].number,
  spacing: _propTypes["default"].number,
  // eslint-disable-next-line react/forbid-prop-types
  gatsbyImageClass: _propTypes["default"].string
};
Field.defaultProps = {
  fill: false,
  lg: 4,
  xs: 12,
  sm: 6,
  md: 4,
  spacing: 6,
  gatsbyImageClass: ''
};

var _default = (0, _Hocs.renderListSafely)(Field);

exports["default"] = _default;